import React, { Component } from "react";
import {
    Container,
    Row,
    Col,
    Card,
    Badge,
    Button,
    Modal,
} from "react-bootstrap";
import gql from "graphql-tag";
import { withApollo } from "react-apollo";
import { withRouter } from "react-router-dom";
import * as compose from "lodash.flowright";
import * as Cookies from "es-cookie";
// MultiSelect is now a custom inline component (see below)
import "../admissionForms/_admissionForms.scss";
import "./_documentServices.scss";
import AddEntryModal from "./AddEntryModal";
import CardLessDataTable from "../datatables/CardLessDataTableWithSearch";

const dash = (cell) => (cell === null || cell === undefined || cell === "") ? "—" : cell;
const GET_DOCUMENT_TYPES = gql`
  query getDocumentTypes {
    getDocumentTypes {
      id
      document_types
      estatus
    }
  }
`;

const GET_DOCUMENT_LOGS = gql`
  query getDocumentLogs(
    $institute_id: Int!
    $branch_id: Int
    $class_id: Int
    $section_id: Int
  ) {
    getDocumentLogs(
      institute_id: $institute_id
      branch_id: $branch_id
      class_id: $class_id
      section_id: $section_id
    ) {
      student_id
      student_name
      student_mobile
      admission_no
      roll_no
      gender
      class_id
      section_id
      branch_id
      institute_id
      father_name
      father_phone
      mother_name
      mother_phone
      dob
      submitted_ids
      submitted_count
      submitted_names
      pending_ids
      pending_count
      pending_names
      returned_ids
      returned_count
      returned_names
      collected_comments
      pending_comments
      return_comments
    }
  }
`;

const DELETE_DOCUMENT_LOG = gql`
  mutation deleteDocumentLog($id: Int!) {
    deleteDocumentLog(id: $id)
  }
`;

const INSERT_DOCUMENT_LOGS = gql`
  mutation insertDocumentLogs($params: [DocumentLogInput]) {
    insertDocumentLogs(params: $params)
  }
`;
// Bulk: send all assigned-document rows in a single mutation

const UPDATE_DOCUMENT_LOG = gql`
  mutation updateDocumentLog($params: UpdateDocumentLogInput!) {
    updateDocumentLog(params: $params)
  }
`;


const GET_BRANCHES = gql`
    query getBranches($institution_id: Int!) {
        getBranches(institution_id: $institution_id) {
            id
            branch_name
            sections {
                id
                class_id
                stream_id
                section_name
            }
        }
    }
`;

const GET_STREAMS = gql`
    query {
        getStreams {
            id
            stream
        }
    }
`;

// Classes that require a stream selection (e.g. Intermediate 1st/2nd year)
const STREAM_CLASS_IDS = [15, 16];
const isStreamClass = (classId) => STREAM_CLASS_IDS.includes(parseInt(classId));

const GET_CLASSES = gql`
    query($id: Int) {
        getExamClasses(id: $id) {
            id
            class
        }
    }
`;



// ── Cert-history style multi-select ───────────────────────────────────────────
const PURPLE = "#6366f1";

function MultiSelect({ label, icon, options, selected, onChange, onToggleOpen, isOpen, idKey = 'id', labelKey = 'label' }) {
    const containerRef = React.useRef(null);
    const [openAbove, setOpenAbove] = React.useState(false);

    React.useEffect(() => {
        if (isOpen && containerRef.current) {
            const rect = containerRef.current.getBoundingClientRect();
            const spaceBelow = window.innerHeight - rect.bottom;
            const spaceAbove = rect.top;
            setOpenAbove(spaceAbove > spaceBelow && spaceBelow < 240);
        }
    }, [isOpen]);

    const allSelected  = options.length > 0 && selected.length === options.length;
    const noneSelected = selected.length === 0;
    const toggleAll    = () => onChange(allSelected ? [] : options.map(o => String(o[idKey])));
    const toggleOne    = (id) => { const sid = String(id); onChange(selected.includes(sid) ? selected.filter(s => s !== sid) : [...selected, sid]); };
    const displayLabel = (noneSelected || allSelected) ? `All ${label}s` : `${selected.length} selected`;
    const dropdownPos  = openAbove
        ? { bottom: '100%', top: 'auto', marginTop: 0, marginBottom: 4 }
        : { top: '100%', bottom: 'auto', marginTop: 4, marginBottom: 0 };

    return (
        <div ref={containerRef} style={{ position: 'relative', zIndex: isOpen ? 200 : 1 }}>
            <div style={ms.label}>{icon && <i className={icon} style={{ marginRight: 5 }} />}{label}</div>
            <button type="button" onClick={onToggleOpen}
                style={{ ...ms.trigger, borderColor: isOpen ? PURPLE : '#d1d5db', boxShadow: isOpen ? `0 0 0 3px ${PURPLE}22` : 'none' }}>
                <span style={{ flex: 1, textAlign: 'left', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', color: '#1f2937' }}>{displayLabel}</span>
                {!noneSelected && !allSelected && (
                    <span style={{ background: PURPLE, color: '#fff', borderRadius: '50%', width: 20, height: 20, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 11, fontWeight: 700, flexShrink: 0 }}>{selected.length}</span>
                )}
                <i className={`fal fa-chevron-${isOpen ? 'up' : 'down'}`} style={{ fontSize: 11, color: '#6b7280', flexShrink: 0 }} />
            </button>
            {isOpen && (
                <div style={{ ...ms.dropdown, ...dropdownPos }}>
                    <label style={ms.checkRow}>
                        <input type="checkbox" checked={allSelected} onChange={toggleAll} style={ms.checkbox} />
                        <span style={{ ...ms.checkLabel, fontWeight: 700, color: '#374151' }}>Select All</span>
                    </label>
                    <div style={{ height: 1, background: '#e5e7eb', margin: '2px 0' }} />
                    <div style={{ maxHeight: 200, overflowY: 'auto' }}>
                        {options.length === 0
                            ? <div style={{ padding: '10px 14px', fontSize: 12, color: '#9ca3af' }}>No options</div>
                            : options.map(opt => {
                                const sid = String(opt[idKey]); const checked = selected.includes(sid);
                                return (
                                    <label key={sid} style={{ ...ms.checkRow, background: checked ? `${PURPLE}08` : 'transparent' }}>
                                        <input type="checkbox" checked={checked} onChange={() => toggleOne(opt[idKey])} style={ms.checkbox} />
                                        <span style={{ ...ms.checkLabel, color: checked ? PURPLE : '#374151', fontWeight: checked ? 600 : 400 }}>{opt[labelKey]}</span>
                                    </label>
                                );
                            })
                        }
                    </div>
                </div>
            )}
        </div>
    );
}

const ms = {
    label:     { fontSize: 11, fontWeight: 700, color: '#6b7280', textTransform: 'uppercase', letterSpacing: '0.5px', marginBottom: 5 },
    trigger:   { width: '100%', display: 'flex', alignItems: 'center', gap: 8, background: '#fff', border: '1.5px solid #d1d5db', borderRadius: 8, padding: '8px 12px', fontSize: 13, cursor: 'pointer', transition: 'all 0.15s' },
    dropdown:  { position: 'absolute', top: '100%', left: 0, right: 0, zIndex: 1000, background: '#fff', border: '1.5px solid #e2e8f0', borderRadius: 10, boxShadow: '0 8px 24px rgba(0,0,0,0.12)', marginTop: 4, overflow: 'hidden' },
    checkRow:  { display: 'flex', alignItems: 'center', gap: 10, padding: '8px 12px', cursor: 'pointer', margin: 0, width: '100%' },
    checkbox:  { width: 16, height: 16, accentColor: PURPLE, cursor: 'pointer', flexShrink: 0 },
    checkLabel:{ fontSize: 13, userSelect: 'none' },
};

// ─────────────────────────────────────────────────────────────────────────────

const DOC_TABS = [
    { key: "history", label: "Dashboard", icon: "fal fa-history" },
    { key: "entry",   label: "Entry",     icon: "fal fa-file-medical" },
];

// ── Main Component ─────────────────────────────────────────────────────────────
class DocumentServiceHome extends Component {

    constructor(props) {
        super(props);

        this.state = {

            // cert-history style multi-select filter state
            selectedBranches:  [],
            selectedClasses:   [],
            selectedStreams:   [],
            selectedSections:  [],
            openDropdown:      null,

            // raw data from GraphQL
            branches:   [],
            getClasses: [],
            allStreams: [],

            // modals
            addEntryModal:  false,
            editMode:       false,
            editStudent:    null,
            deleteModal:    false,
            deleteStudent:  null,
            showDrawer:     false,
            selectedStudent: {},
            drawerDocLogs:  [],   // per-document detail records (with comments) for view modal

            allDocuments: [],
            rawDocumentTypes: [],

            students: [],
            loading: false,
            fetchError: null,
        };

        this.filterRef = React.createRef();
    }

    componentDidMount() {
        document.addEventListener('mousedown', this.handleOutsideClick);
        this.getBranches();
        this.getClasses();
        this.getStreamsList();
        this.getDocumentTypes();
    }

    // ── Stream helpers: stream only narrows the section list (sections carry stream_id) ──
    streamIdsFor = (branchObjs, classIds) =>
        Array.from(new Set(
            branchObjs.flatMap(b => b.sections || [])
                .filter(s => classIds.includes(String(s.class_id)) && isStreamClass(s.class_id) && s.stream_id)
                .map(s => String(s.stream_id))
        ));

    sectionIdsFor = (branchObjs, classIds, streamIds) =>
        branchObjs.flatMap(b => b.sections || [])
            .filter(s => classIds.includes(String(s.class_id)))
            .filter(s => !isStreamClass(s.class_id) || streamIds.includes(String(s.stream_id)))
            .map(s => String(s.id));

    getStreamsList = async () => {
        try {
            const result = await this.props.client.query({
                query: GET_STREAMS,
                fetchPolicy: "network-only",
            });
            this.setState({ allStreams: result.data.getStreams || [] });
        } catch {}
    };

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleOutsideClick);
    }

    handleOutsideClick = (e) => {
        if (this.filterRef.current && !this.filterRef.current.contains(e.target))
            this.setState({ openDropdown: null });
    };

    getDocumentTypes = async () => {
        try {
            const result = await this.props.client.query({
                query: GET_DOCUMENT_TYPES,
                fetchPolicy: "network-only",
            });
            const docTypes = result.data.getDocumentTypes || [];
            this.setState({
                allDocuments: docTypes.map(d => d.document_types),
                rawDocumentTypes: docTypes,
            });
        } catch (e) {
            console.error(e);
        }
    };

    fetchStudentDocuments = async () => {
        const institute_id = parseInt(
            Cookies.get("institutionid") || Cookies.get("institute_id") || "0", 10
        );
        if (!institute_id) {
            this.setState({ students: [], loading: false, fetchError: "Institution not found. Please re-login." });
            return;
        }

        // Pass a single-value filter when exactly one item is selected;
        // otherwise null → backend returns all for the institute
        const { selectedBranches, selectedClasses, selectedSections } = this.state;
        const branch_id  = selectedBranches.length  === 1 ? parseInt(selectedBranches[0],  10) : null;
        const class_id   = selectedClasses.length   === 1 ? parseInt(selectedClasses[0],   10) : null;
        const section_id = selectedSections.length  === 1 ? parseInt(selectedSections[0],  10) : null;

        this.setState({ loading: true, fetchError: null });
        try {
            const result = await this.props.client.query({
                query: GET_DOCUMENT_LOGS,
                variables: { institute_id, branch_id, class_id, section_id },
                fetchPolicy: "network-only",
            });
            const students = (result.data && result.data.getDocumentLogs) || [];
            this.setState({ students, loading: false, fetchError: null });
        } catch (e) {
            console.error("fetchStudentDocuments error:", e);
            this.setState({
                students: [],
                loading: false,
                fetchError: e.message || "Failed to load student documents",
            });
        }
    };

    getBranches = async () => {
        try {
            const instIdStr = Cookies.get("institutionid") || Cookies.get("institute_id") || "0";
            const institution_id = parseInt(instIdStr, 10);
            if (!institution_id) return;
            const result = await this.props.client.query({
                query: GET_BRANCHES,
                variables: { institution_id },
                fetchPolicy: "network-only",
            });
            const branches = result.data.getBranches || [];
            const allClassIds   = Array.from(new Set(branches.flatMap(b => b.sections || []).map(s => String(s.class_id))));
            const allStreamIds  = this.streamIdsFor(branches, allClassIds);
            const allSectionIds = this.sectionIdsFor(branches, allClassIds, allStreamIds);
            this.setState({
                branches,
                selectedBranches:  branches.map(b => String(b.id)),
                selectedClasses:   allClassIds,
                selectedStreams:   allStreamIds,
                selectedSections:  allSectionIds,
            }, this.fetchStudentDocuments);
        } catch {}
    };

    getClasses = async () => {
        try {
            const result = await this.props.client.query({
                query: GET_CLASSES,
                variables: { id: 1 },
                fetchPolicy: "network-only",
            });
            const classes = result.data.getExamClasses || [];
            this.setState({ getClasses: classes });
        } catch {}
    };

    openDrawer = (student) => {
        const submittedNames = this._parseNames(student.submitted_names);
        const pendingNames   = this._parseNames(student.pending_names);
        const returnedNames  = this._parseNames(student.returned_names);

        // Each comment field is parallel to its own names array
        const collectedMap = this._parseCommentMap(student.collected_comments, submittedNames);
        const pendingMap   = this._parseCommentMap(student.pending_comments,   pendingNames);
        const returnMap    = this._parseCommentMap(student.return_comments,    returnedNames);

        const drawerDocLogs = [
            ...submittedNames.map(name => ({
                document_type_name: name,
                collected_comments: collectedMap[name] || '',
                pending_comments:   '',
                return_comments:    '',
            })),
            ...pendingNames.map(name => ({
                document_type_name: name,
                collected_comments: '',
                pending_comments:   pendingMap[name] || '',
                return_comments:    '',
            })),
            ...returnedNames.map(name => ({
                document_type_name: name,
                collected_comments: '',
                pending_comments:   '',
                return_comments:    returnMap[name] || '',
            })),
        ];

        this.setState({ showDrawer: true, selectedStudent: student, drawerDocLogs });
    };

    closeDrawer = () => {
        this.setState({ showDrawer: false, selectedStudent: {}, drawerDocLogs: [] });
    };

    openEditModal = (student) => {
        this.setState({ addEntryModal: true, editMode: true, editStudent: student });
    };

    formatDate = (dateString) => {
        if (!dateString) return "";
        return new Date(dateString).toLocaleDateString("en-GB", {
            day: "2-digit", month: "short", year: "numeric",
        });
    };

    // ── Helpers to normalise IDs / names coming from GraphQL (array | CSV string) ──
    _parseIds = (raw) => {
        if (!raw) return [];
        if (Array.isArray(raw)) return raw.filter(Boolean).map(x => parseInt(x, 10)).filter(n => !isNaN(n));
        const s = String(raw).trim();
        if (!s) return [];
        try { const p = JSON.parse(s); if (Array.isArray(p)) return p.map(x => parseInt(x,10)).filter(n=>!isNaN(n)); } catch {}
        return s.split(',').map(x => parseInt(x.trim(), 10)).filter(n => !isNaN(n));
    };
    _parseNames = (raw) => {
        if (!raw) return [];
        if (Array.isArray(raw)) return raw.filter(Boolean).map(s => String(s).trim());
        const s = String(raw).trim();
        if (!s) return [];
        try { const p = JSON.parse(s); if (Array.isArray(p)) return p.filter(Boolean).map(x => String(x).trim()); } catch {}
        return s.split(',').map(x => x.trim()).filter(Boolean);
    };

    // Each comment field from the backend is a "||"-separated string parallel to its names array.
    // Returns {docName: commentString}.
    _parseCommentMap = (raw, docNames = []) => {
        if (raw === null || raw === undefined) return {};

        // Native JS array — positional match
        if (Array.isArray(raw)) {
            const map = {};
            docNames.forEach((name, i) => { if (raw[i]) map[name] = String(raw[i]); });
            return map;
        }

        // Native JS object — already keyed by docName
        if (typeof raw === 'object') return raw;

        const s = String(raw).trim();
        if (!s) return {};

        // Try JSON first
        try {
            const parsed = JSON.parse(s);
            if (Array.isArray(parsed)) {
                const map = {};
                docNames.forEach((name, i) => { if (parsed[i]) map[name] = String(parsed[i]); });
                return map;
            }
            if (parsed && typeof parsed === 'object') return parsed;
        } catch {}

        // Backend returns "||"-separated string — split and map positionally
        const parts = s.split('||').map(x => x.trim());
        const map = {};
        docNames.forEach((name, i) => { if (parts[i]) map[name] = parts[i]; });
        return map;
    };

    handleSaveEntry = async (studentData) => {
        try {
            const edu_student_id = parseInt(
                this.state.editMode
                    ? (this.state.editStudent?.student_id || this.state.editStudent?.id)
                    : studentData.selectedStudentId,
                10
            );
            if (!edu_student_id) {
                return { ok: false, message: "Please select a student before saving." };
            }

            const collected_by = parseInt(Cookies.get("id") || Cookies.get("user_id") || "0", 10);
            const { rawDocumentTypes } = this.state;
            const docStatus    = studentData.docStatus || {};

            // ════════════════════════════════════════════════════════════════
            // EDIT MODE — smart update / insert / delete
            // ════════════════════════════════════════════════════════════════
            if (this.state.editMode) {
                const es = this.state.editStudent;

                // Build name → log-record-ID map from the three lists
                const prevSubNames = this._parseNames(es.submitted_names);
                const prevSubIds   = this._parseIds(es.submitted_ids);
                const prevPenNames = this._parseNames(es.pending_names);
                const prevPenIds   = this._parseIds(es.pending_ids);
                const prevRetNames = this._parseNames(es.returned_names);
                const prevRetIds   = this._parseIds(es.returned_ids);

                const existingMap = {}; // docName → log record id
                prevSubNames.forEach((name, i) => { existingMap[name] = prevSubIds[i]; });
                prevPenNames.forEach((name, i) => { existingMap[name] = prevPenIds[i]; });
                prevRetNames.forEach((name, i) => { existingMap[name] = prevRetIds[i]; });

                // ── Previous status per document (to detect changes) ──
                const prevStatusMap = {}; // docName → { collected, returned }
                prevSubNames.forEach(name => { prevStatusMap[name] = { collected: true,  returned: false }; });
                prevPenNames.forEach(name => { prevStatusMap[name] = { collected: false, returned: false }; });
                prevRetNames.forEach(name => { prevStatusMap[name] = { collected: true,  returned: true  }; });

                // ── Change detection ──
                // Flag a change when:
                //   1. A new doc was assigned (brand-new)
                //   2. An existing doc had its submitted/pending/returned status flipped
                //   3. A previously-assigned doc is now unselected (needs removal)
                let hasChanges = false;

                // Check new assignments + status flips
                for (const [docName, status] of Object.entries(docStatus)) {
                    if (!status.assigned) continue;
                    if (!prevStatusMap[docName]) { hasChanges = true; break; }
                    const prev = prevStatusMap[docName];
                    if (prev.collected !== status.collected || prev.returned !== status.returned) {
                        hasChanges = true; break;
                    }
                }

                // Check unselected docs (previously assigned → now unchecked = remove)
                if (!hasChanges) {
                    for (const docName of Object.keys(existingMap)) {
                        const cur = docStatus[docName];
                        if (!cur || !cur.assigned) { hasChanges = true; break; }
                    }
                }

                // Check comment changes on existing docs (collected_comments or return_comments)
                if (!hasChanges) {
                    for (const [docName, status] of Object.entries(docStatus)) {
                        if (!status.assigned) continue;
                        if (!Object.prototype.hasOwnProperty.call(existingMap, docName)) continue;
                        if (status.collected_comments || status.return_comments) {
                            hasChanges = true; break;
                        }
                    }
                }

                if (!hasChanges) {
                    return { ok: true, noChanges: true, message: "No changes detected. Records remain unchanged." };
                }

                // ── Build three buckets ──
                const docsToUpdate          = [];   // existing docs whose status changed
                const newDocs               = [];   // brand-new docs → { id, collected, returned, comments }
                const removeDocumentTypeIds = [];   // unselected docs → remove via updateDocumentLog

                // Walk current docStatus to find updates + new inserts
                for (const [docName, status] of Object.entries(docStatus)) {
                    const docType = rawDocumentTypes.find(d => d.document_types === docName);
                    if (!docType) continue;
                    const document_type_id = parseInt(docType.id, 10);

                    if (Object.prototype.hasOwnProperty.call(existingMap, docName)) {
                        if (status.assigned) {
                            // Existing doc — only update if status or comments actually changed
                            const prev = prevStatusMap[docName];
                            const statusChanged = !prev
                                || prev.collected !== status.collected
                                || prev.returned  !== status.returned;
                            // Comments are always empty on load (backend doesn't return per-doc comments),
                            // so any non-empty comment in this session is a genuine new change.
                            const commentChanged = !!(status.collected_comments || status.return_comments);
                            if (statusChanged || commentChanged) {
                                docsToUpdate.push({
                                    document_type_id,
                                    collected_status:   status.collected ? 1 : 0,
                                    collected_by:       status.collected ? collected_by : 0,
                                    collected_comments: status.collected_comments || "",
                                    returned_status:    status.returned  ? 1 : 0,
                                    returned_by:        status.returned  ? collected_by : 0,
                                    return_comments:    status.return_comments || "",
                                });
                            }
                            // if unchanged, skip — no call needed
                        }
                        // if !status.assigned → handled below via existingMap loop
                    } else if (status.assigned) {
                        // Brand-new doc added during this edit session
                        newDocs.push({
                            id:       document_type_id,
                            collected: status.collected,
                            returned:  status.returned,
                            comments:  status.collected_comments || "",
                        });
                    }
                }

                // Walk existingMap to find unselected (removed) docs
                for (const docName of Object.keys(existingMap)) {
                    const cur = docStatus[docName];
                    if (!cur || !cur.assigned) {
                        const docType = rawDocumentTypes.find(d => d.document_types === docName);
                        if (docType) removeDocumentTypeIds.push(parseInt(docType.id, 10));
                    }
                }

                // ── Fire all update calls in parallel ──
                // Each call handles one status change; removes are attached to the
                // first call to avoid a separate round-trip.
                if (docsToUpdate.length > 0 || removeDocumentTypeIds.length > 0) {
                    const updateCalls = docsToUpdate.map((d, i) =>
                        this.props.client.mutate({
                            mutation: UPDATE_DOCUMENT_LOG,
                            variables: {
                                params: {
                                    edu_student_id,
                                    ...d,
                                    // Attach all removals to the first call (free ride)
                                    ...(i === 0 && removeDocumentTypeIds.length > 0
                                        ? { remove_document_type_ids: removeDocumentTypeIds }
                                        : {}),
                                },
                            },
                        })
                    );

                    // No status updates but there ARE removals → standalone remove call
                    if (docsToUpdate.length === 0 && removeDocumentTypeIds.length > 0) {
                        updateCalls.push(
                            this.props.client.mutate({
                                mutation: UPDATE_DOCUMENT_LOG,
                                variables: {
                                    params: {
                                        edu_student_id,
                                        remove_document_type_ids: removeDocumentTypeIds,
                                    },
                                },
                            })
                        );
                    }

                    await Promise.all(updateCalls);
                }

                // Insert brand-new documents added during edit — single bulk call
                if (newDocs.length > 0) {
                    const editNow = new Date().toISOString();
                    const params = newDocs.map(doc => ({
                        edu_student_id,
                        document_type_id:   doc.id,
                        collected_status:   doc.collected ? 1 : 0,
                        collected_date:     doc.collected ? editNow : null,
                        collected_by:       doc.collected ? collected_by : 0,
                        collected_comments: doc.comments || "",
                        file_url:           "",
                        returned_status:    doc.returned ? 1 : 0,
                        returned_date:      doc.returned ? editNow : null,
                        returned_by:        doc.returned ? collected_by : 0,
                        return_comments:    doc.return_comments || "",
                    }));
                    await this.props.client.mutate({
                        mutation: INSERT_DOCUMENT_LOGS,
                        variables: { params },
                    });
                }

                this.fetchStudentDocuments();
                // Don't close the modal here — AddEntryModal will show the
                // success message first, then close the modal after a short delay.
                return { ok: true, message: "Updated successfully!" };
            }

            // ════════════════════════════════════════════════════════════════
            // NEW ENTRY MODE — duplicate check + insert
            // ════════════════════════════════════════════════════════════════
            const existing = this.state.students.find(s => parseInt(s.student_id, 10) === edu_student_id);
            if (existing) {
                return {
                    ok: false,
                    message: `Document entry already exists for "${existing.student_name}". Use the Edit button in History to update their records.`,
                };
            }

            // Bulk insert — one call carrying all assigned-document rows
            const now = new Date().toISOString();
            const params = [];

            for (const [docName, status] of Object.entries(docStatus)) {
                if (!status.assigned) continue;
                const docType = rawDocumentTypes.find(d => d.document_types === docName);
                if (!docType) continue;

                params.push({
                    edu_student_id,
                    document_type_id:   parseInt(docType.id, 10),
                    collected_status:   status.collected ? 1 : 0,
                    collected_date:     status.collected ? now : null,
                    collected_by:       status.collected ? collected_by : 0,
                    collected_comments: status.collected_comments || "",
                    file_url:           "",
                    returned_status:    status.returned ? 1 : 0,
                    returned_date:      status.returned ? now : null,
                    returned_by:        status.returned ? collected_by : 0,
                    return_comments:    status.return_comments || "",
                });
            }

            if (params.length > 0) {
                await this.props.client.mutate({
                    mutation: INSERT_DOCUMENT_LOGS,
                    variables: { params },
                });
            }

            this.fetchStudentDocuments();
            this.setState({ addEntryModal: false });
            return { ok: true, message: "Document entry saved successfully!" };

        } catch (e) {
            console.error("Error saving entry:", e);
            return { ok: false, message: "Error saving document entry: " + (e.message || "Unknown error") };
        }
    };

    openDeleteModal = (student) => {
        this.setState({ deleteModal: true, deleteStudent: student });
    };

    handleDeleteStudent = async () => {
        try {
            const student = this.state.deleteStudent;
            if (student) {
                // Collect all document log IDs from submitted + returned + pending
                const allDocIds = [
                    ...(student.submitted_ids || []),
                    ...(student.returned_ids  || []),
                    ...(student.pending_ids   || []),
                ].filter(Boolean);
                for (const id of allDocIds) {
                    await this.props.client.mutate({
                        mutation: DELETE_DOCUMENT_LOG,
                        variables: { id: parseInt(id, 10) }
                    });
                }
            }
            this.fetchStudentDocuments();
            this.setState({ deleteModal: false, deleteStudent: null });
        } catch (e) {
            console.error("Error deleting documents:", e);
            alert("Error deleting documents");
        }
    };

    tableData = (students, branchMap, classMap, sectionMap) => {
        return students.map((s, i) => ({
            sno:            i + 1,
            id:             s.student_id,
            student_id:     s.student_id,
            admission_no:   s.admission_no || "",
            roll_no:        s.roll_no || "",
            student_name:   s.student_name || "",
            gender:         s.gender || "",
            student_mobile: s.student_mobile || "",
            father_name:    s.father_name || "",
            father_phone:   s.father_phone || "",
            mother_name:    s.mother_name || "",
            dob:            s.dob ? this.formatDate(s.dob) : "",
            branch_name:    branchMap[String(s.branch_id)] || "",
            class_name:     classMap[String(s.class_id)] || "",
            section_name:   sectionMap[String(s.section_id)] || "",
            submitted_names: s.submitted_names,
            pending_names:   s.pending_names,
            returned_names:  s.returned_names,
            _row: s,
        }));
    };

    articlecolumns = [
        { dataField: "sno",           text: "#",            formatter: (cell, row, idx) => idx + 1 },
        { dataField: "admission_no",  text: "Admission No", sort: true, formatter: (cell) => <span className="dh-adm-badge">#{cell || '—'}</span> },
        { dataField: "roll_no",       text: "Roll No",      sort: true, formatter: dash },
        { dataField: "student_name",  text: "Student Name", sort: true, formatter: (cell, row) => (
            <div style={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
                <span style={{ fontWeight: 600, color: '#1f2937', whiteSpace: 'nowrap' }}>{cell || '—'}</span>
                {row.gender && (
                    <span style={{ background: row.gender.toLowerCase() === 'male' ? '#dbeafe' : '#fce7f3', color: row.gender.toLowerCase() === 'male' ? '#1d4ed8' : '#be185d', borderRadius: 10, fontSize: 10, fontWeight: 700, padding: '1px 7px', alignSelf: 'flex-start' }}>
                        {row.gender}
                    </span>
                )}
            </div>
        ) },
        { dataField: "student_mobile", text: "Mobile",       sort: true, formatter: dash },
        { dataField: "father_name",    text: "Father Name",  sort: true, formatter: dash },
        { dataField: "father_phone",   text: "Father Phone", sort: true, formatter: dash },
        { dataField: "mother_name",    text: "Mother Name",  sort: true, formatter: dash },
        { dataField: "dob",            text: "DOB",          sort: true, formatter: dash },
        { dataField: "branch_name",    text: "Branch",       sort: true, formatter: dash },
        { dataField: "class_name",     text: "Class",        sort: true, formatter: dash },
        { dataField: "section_name",   text: "Section",      sort: true, formatter: dash },
        { dataField: "submitted_names", text: "Submitted",   formatter: (cell) => this.renderChips(cell, "green") },
        { dataField: "pending_names",   text: "Pending",     formatter: (cell) => this.renderChips(cell, "red") },
        { dataField: "returned_names",  text: "Returned",    formatter: (cell) => this.renderChips(cell, "blue") },
        { dataField: "actions", text: "Actions", classes: "dh-sticky-actions", headerClasses: "dh-sticky-actions", formatter: (cell, row) => (
            <div className="dh-action-wrap">
                <button className="dh-view-btn" onClick={() => this.openDrawer(row._row)}>
                    <i className="fas fa-eye" /> View
                </button>
                <button className="dh-edit-btn" onClick={() => this.openEditModal(row._row)}>
                    <i className="fas fa-arrow-right" /> Edit
                </button>
            </div>
        ) },
    ];

    renderChips = (documents, type) => {
        // Normalise: backend returns comma-separated string, JSON array string, or JS array
        let safeArr = [];
        if (Array.isArray(documents)) {
            safeArr = documents.filter(Boolean);
        } else if (typeof documents === "string" && documents.trim()) {
            try {
                const parsed = JSON.parse(documents);
                safeArr = Array.isArray(parsed) ? parsed.filter(Boolean) : documents.split(",").map(s => s.trim()).filter(Boolean);
            } catch {
                // comma-separated string (may have ", " or "," as separator)
                safeArr = documents.split(",").map(s => s.trim()).filter(Boolean);
            }
        }
        return safeArr.map((doc, index) => (
            <Badge
                key={index}
                className={
                    type === "green" ? "dh-chip-green" :
                    type === "blue"  ? "dh-chip-blue"  :
                                       "dh-chip-red"
                }
            >
                {doc}
            </Badge>
        ));
    };

    render() {

        const activeTab = (this.props.match && this.props.match.params && this.props.match.params.tab) || "history";

        const { students, selectedBranches, selectedClasses, selectedStreams, selectedSections, openDropdown,
                branches, getClasses, allStreams, loading, fetchError } = this.state;

        // ── Client-side filtering (branch / class / section) ──────────────────
        // Search is handled by CardLessDataTable's built-in search bar.
        const filteredStudents = students.filter(s => {
            if (selectedBranches.length > 0 && !selectedBranches.includes(String(s.branch_id)))   return false;
            if (selectedClasses.length  > 0 && !selectedClasses.includes(String(s.class_id)))    return false;
            if (selectedSections.length > 0 && !selectedSections.includes(String(s.section_id))) return false;
            return true;
        });

        // ── Lookup maps for branch / class / section names ─────────────────────
        const branchMap  = Object.fromEntries((branches  || []).map(b => [String(b.id), b.branch_name]));
        const classMap   = Object.fromEntries((getClasses || []).map(c => [String(c.id), c.class]));
        const sectionMap = Object.fromEntries(
            (branches || []).flatMap(b => b.sections || []).map(s => [String(s.id), s.section_name])
        );

        const documentsReceivedCount = students.reduce((t, s) => t + (s.submitted_count || 0), 0);
        const pendingDocumentsCount  = students.reduce((t, s) => t + (s.pending_count  || 0), 0);
        const returnedDocumentsCount = students.reduce((t, s) => t + (s.returned_count || 0), 0);
        const totalSubmittedCount    = documentsReceivedCount + pendingDocumentsCount + returnedDocumentsCount;

        // ── Cert-history style derived filter options ──────────────────────────
        const branchOptions = branches.map(b => ({ id: b.id, label: b.branch_name }));

        const selectedBranchObjs = selectedBranches.length > 0
            ? branches.filter(b => selectedBranches.includes(String(b.id)))
            : branches;
        const classIdSet = new Set(selectedBranchObjs.flatMap(b => b.sections || []).map(s => String(s.class_id)));
        const classOptions = getClasses
            .filter(c => classIdSet.has(String(c.id)))
            .sort((a, b) => Number(a.id) - Number(b.id))
            .map(c => ({ id: c.id, label: String(c.class) }));

        // Stream options — only the streams that exist among the selected stream-classes' sections
        const streamOptions = this.streamIdsFor(selectedBranchObjs, selectedClasses)
            .map(sid => { const st = allStreams.find(s => String(s.id) === String(sid)); return st ? { id: sid, label: st.stream } : null; })
            .filter(Boolean);
        const showStream = streamOptions.length > 0;

        const sectionOptions = selectedBranchObjs
            .flatMap(b => b.sections || [])
            .filter(s => selectedClasses.length === 0 || selectedClasses.includes(String(s.class_id)))
            .filter(s => !isStreamClass(s.class_id) || selectedStreams.includes(String(s.stream_id)))
            .map(s => ({ id: s.id, label: s.section_name }));

        // Build comment lookup map: document_type_name → { collected_comments, pending_comments, return_comments }
        const docCommentMap = {};
        (this.state.drawerDocLogs || []).forEach(log => {
            if (log.document_type_name) {
                docCommentMap[log.document_type_name] = {
                    collected_comments: log.collected_comments || "",
                    pending_comments:   log.pending_comments   || "",
                    return_comments:    log.return_comments    || "",
                };
            }
        });

        return (
        <>

            <div style={{ background: "linear-gradient(135deg, #f0f4ff 0%, #faf5ff 100%)", minHeight: "100vh", padding: "24px 28px", marginBottom: 100 }}>

                <Container fluid className="px-0">

                    <div style={{ background: "#fff", borderRadius: 16, boxShadow: "0 4px 24px rgba(0,0,0,0.05)", overflow: "hidden", border: "1px solid #e2e8f0" }}>

                        {/* Tab header */}
                        <div style={{ background: "#f8fafc", borderBottom: "1.5px solid #e2e8f0", padding: "12px 24px 0 24px" }}>
                            <ul className="nav nav-tabs" style={{ borderBottom: "none", gap: 8 }}>
                                {DOC_TABS.map((tab) => {
                                    const isActive = activeTab === tab.key;
                                    return (
                                        <li className="nav-item" key={tab.key}>
                                            <a
                                                className={`nav-link ${isActive ? "active" : ""}`}
                                                onClick={() => {
                                                    if (tab.key === "entry") this.setState({ editMode: false, editStudent: null });
                                                    if (tab.key === "history") this.fetchStudentDocuments();
                                                    this.props.history.push('/document-services/' + tab.key);
                                                }}
                                                style={{
                                                    cursor: "pointer",
                                                    fontWeight: 700,
                                                    fontSize: 14,
                                                    display: "flex",
                                                    alignItems: "center",
                                                    gap: 8,
                                                    padding: "12px 20px",
                                                    color: isActive ? "#6366f1" : "#4b5563",
                                                    background: isActive ? "#fff" : "transparent",
                                                    borderColor: isActive ? "#e2e8f0 #e2e8f0 #fff" : "transparent",
                                                    borderWidth: "1.5px",
                                                    borderBottomWidth: isActive ? "2px" : "1.5px",
                                                    borderRadius: "10px 10px 0 0",
                                                    transition: "all 0.15s ease",
                                                    marginBottom: "-1.5px",
                                                    textDecoration: "none",
                                                }}
                                            >
                                                <i className={tab.icon} />
                                                {tab.label}
                                            </a>
                                        </li>
                                    );
                                })}
                            </ul>
                        </div>

                        {/* Content panel */}
                        <div style={{ padding: "28px" }}>

                    {activeTab === "entry" && (
                        <AddEntryModal
                            inline
                            show={true}
                            editMode={false}
                            editStudent={null}
                            existingStudentIds={this.state.students.map(s => String(s.student_id))}
                            onSave={(data) => this.handleSaveEntry(data)}
                            onHide={() => this.props.history.push('/document-services/history')}
                        />
                    )}

                    {activeTab === "history" && <>

                    {/* ANALYTICS */}
                    <Row className="mb-2">

                        <Col md={3}>
                            <div className="dh-stat-card dh-stat-total">
                                <div className="dh-stat-icon total-icon">
                                    <i className="fas fa-layer-group" />
                                </div>
                                <div className="dh-stat-content">
                                    <span className="dh-stat-label">Total Documents</span>
                                    <span className="dh-stat-value total-value">{totalSubmittedCount}</span>
                                </div>
                            </div>
                        </Col>

                        <Col md={3}>
                            <div className="dh-stat-card dh-stat-success">
                                <div className="dh-stat-icon success-icon">
                                    <i className="fas fa-file-alt" />
                                </div>
                                <div className="dh-stat-content">
                                    <span className="dh-stat-label">Documents Received</span>
                                    <span className="dh-stat-value success-value">{documentsReceivedCount}</span>
                                </div>
                            </div>
                        </Col>

                        <Col md={3}>
                            <div className="dh-stat-card dh-stat-warning">
                                <div className="dh-stat-icon warning-icon">
                                    <i className="fas fa-hourglass-half" />
                                </div>
                                <div className="dh-stat-content">
                                    <span className="dh-stat-label">Pending Documents</span>
                                    <span className="dh-stat-value warning-value">{pendingDocumentsCount}</span>
                                </div>
                            </div>
                        </Col>

                        <Col md={3}>
                            <div className="dh-stat-card dh-stat-returned">
                                <div className="dh-stat-icon danger-icon">
                                    <i className="fas fa-reply" />
                                </div>
                                <div className="dh-stat-content">
                                    <span className="dh-stat-label">Returned Documents</span>
                                    <span className="dh-stat-value danger-value">{returnedDocumentsCount}</span>
                                </div>
                            </div>
                        </Col>

                    </Row>

                    {/* TABLE + FILTERS */}
                    <Card className="dh-table-card">

                        {/* Modern Card Header */}
                        <div className="dh-table-header">
                            <div style={{ display: 'flex', alignItems: 'center', gap: 14, marginBottom: 14 }}>
                                <div style={{ background: `${PURPLE}15`, color: PURPLE, borderRadius: 8, width: 30, height: 30, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                    <i className="fal fa-sliders-h" style={{ fontSize: 13 }} />
                                </div>
                                <span style={{ fontWeight: 700, fontSize: 13, color: '#1f2937' }}>Filters</span>
                            </div>
                            <span className="dh-record-badge">
                                {filteredStudents.length} {filteredStudents.length === 1 ? "student" : "students"}
                            </span>
                        </div>

                        {/* Filter bar — cert-history style */}
                        <div style={{ background: '#fff',  padding: '16px 20px', marginBottom: 20, marginTop: 12 }} ref={this.filterRef}>
                            {/* Header */}
                         

                            {/* grid: Branch | Class | (Stream) | Section (search lives inside the table) */}
                            <div style={{ display: 'grid', gridTemplateColumns: showStream ? '1fr 1fr 1fr 1fr' : '1fr 1fr 1fr', gap: 14 }}>

                                {/* Branch */}
                                <MultiSelect
                                    label="Branch" icon="fal fa-code-branch"
                                    options={branchOptions} selected={selectedBranches}
                                    onChange={val => {
                                        const selBranches   = branches.filter(b => val.includes(String(b.id)));
                                        const newClassIds   = Array.from(new Set(selBranches.flatMap(b => b.sections || []).map(s => String(s.class_id))));
                                        const newStreamIds  = this.streamIdsFor(selBranches, newClassIds);
                                        const newSectionIds = this.sectionIdsFor(selBranches, newClassIds, newStreamIds);
                                        this.setState({ selectedBranches: val, selectedClasses: newClassIds, selectedStreams: newStreamIds, selectedSections: newSectionIds }, this.fetchStudentDocuments);
                                    }}
                                    onToggleOpen={() => this.setState({ openDropdown: openDropdown === 'branch' ? null : 'branch' })}
                                    isOpen={openDropdown === 'branch'}
                                />

                                {/* Class */}
                                <MultiSelect
                                    label="Class" icon="fal fa-layer-group"
                                    options={classOptions} selected={selectedClasses}
                                    onChange={val => {
                                        const selBranches   = selectedBranches.length > 0 ? branches.filter(b => selectedBranches.includes(String(b.id))) : branches;
                                        const newStreamIds  = this.streamIdsFor(selBranches, val);
                                        const newSectionIds = this.sectionIdsFor(selBranches, val, newStreamIds);
                                        this.setState({ selectedClasses: val, selectedStreams: newStreamIds, selectedSections: newSectionIds }, this.fetchStudentDocuments);
                                    }}
                                    onToggleOpen={() => this.setState({ openDropdown: openDropdown === 'class' ? null : 'class' })}
                                    isOpen={openDropdown === 'class'}
                                />

                                {/* Stream — only for stream classes (Intermediate) */}
                                {showStream && (
                                    <MultiSelect
                                        label="Stream" icon="fal fa-stream"
                                        options={streamOptions} selected={selectedStreams}
                                        onChange={val => {
                                            const selBranches   = selectedBranches.length > 0 ? branches.filter(b => selectedBranches.includes(String(b.id))) : branches;
                                            const newSectionIds = this.sectionIdsFor(selBranches, selectedClasses, val);
                                            this.setState({ selectedStreams: val, selectedSections: newSectionIds }, this.fetchStudentDocuments);
                                        }}
                                        onToggleOpen={() => this.setState({ openDropdown: openDropdown === 'stream' ? null : 'stream' })}
                                        isOpen={openDropdown === 'stream'}
                                    />
                                )}

                                {/* Section */}
                                <MultiSelect
                                    label="Section" icon="fal fa-users"
                                    options={sectionOptions} selected={selectedSections}
                                    onChange={val => this.setState({ selectedSections: val }, this.fetchStudentDocuments)}
                                    onToggleOpen={() => this.setState({ openDropdown: openDropdown === 'section' ? null : 'section' })}
                                    isOpen={openDropdown === 'section'}
                                />

                            </div>
                        </div>

                        <div style={{ padding: "16px 24px" }}>
                            {loading ? (
                                <>
                                    <style>{`
                                        @keyframes dh-shimmer {
                                            0%   { background-position: -800px 0; }
                                            100% { background-position:  800px 0; }
                                        }
                                        .dh-shimmer {
                                            background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
                                            background-size: 800px 100%;
                                            animation: dh-shimmer 1.4s infinite linear;
                                            border-radius: 5px;
                                        }
                                    `}</style>
                                    {/* shimmer search bar */}
                                    <div style={{ marginBottom: 14 }}>
                                        <div className="dh-shimmer" style={{ height: 34, width: 220, borderRadius: 8 }} />
                                    </div>
                                    {/* shimmer header */}
                                    <div style={{ display: "flex", gap: 10, padding: "10px 0", borderBottom: "2px solid #f3f4f6", marginBottom: 4 }}>
                                        {[40, 110, 70, 130, 90, 110, 90, 110, 80, 90, 60, 70, 90, 80, 80, 90].map((w, i) => (
                                            <div key={i} className="dh-shimmer" style={{ height: 13, width: w, flexShrink: 0 }} />
                                        ))}
                                    </div>
                                    {/* shimmer rows */}
                                    {[1, 2, 3, 4, 5, 6, 7].map(row => (
                                        <div key={row} style={{ display: "flex", gap: 10, padding: "13px 0", borderBottom: "1px solid #f3f4f6", alignItems: "center" }}>
                                            {[40, 110, 70, 130, 90, 110, 90, 110, 80, 90, 60, 70, 90, 80, 80, 90].map((w, i) => (
                                                <div key={i} className="dh-shimmer" style={{ height: 12, width: w, flexShrink: 0 }} />
                                            ))}
                                        </div>
                                    ))}
                                </>
                            ) : fetchError ? (
                                <div style={{ textAlign: "center", padding: "32px 0", color: "#dc2626" }}>
                                    <i className="fas fa-exclamation-circle" style={{ marginRight: 8 }} />
                                    <span style={{ fontSize: 13, fontWeight: 600 }}>{fetchError}</span>
                                </div>
                            ) : (
                                <CardLessDataTable
                                    parentData={this.tableData(filteredStudents, branchMap, classMap, sectionMap)}
                                    particlecolumns={this.articlecolumns}
                                    search={true}
                                    name="document_services_history"
                                />
                            )}
                        </div>

                    </Card>

                    </>}

                        </div>{/* /content panel */}
                    </div>{/* /card */}

                    {/* STUDENT DETAILS MODAL */}
                    <Modal
                        show={this.state.showDrawer}
                        onHide={this.closeDrawer}
                        size="lg"
                        centered
                        dialogClassName="dh-custom-modal"
                    >
                        {/* ── Gradient Header ── */}
                        <Modal.Header
                            closeButton
                            style={{
                                background: 'linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)',
                                border: 'none',
                                padding: '22px 24px',
                                position: 'relative',
                            }}
                        >
                            <div style={{ display: 'flex', alignItems: 'center', gap: 16, flex: 1 }}>
                                {/* Avatar */}
                                <div style={{
                                    width: 58, height: 58, borderRadius: '50%',
                                    background: 'rgba(255,255,255,0.2)',
                                    border: '2.5px solid rgba(255,255,255,0.5)',
                                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                                    color: '#fff', fontSize: 24, fontWeight: 800, flexShrink: 0,
                                    letterSpacing: '-1px',
                                }}>
                                    {this.state.selectedStudent.student_name
                                        ? this.state.selectedStudent.student_name.charAt(0).toUpperCase()
                                        : '?'}
                                </div>
                                <div style={{ flex: 1, minWidth: 0 }}>
                                    <div style={{ color: '#fff', fontWeight: 800, fontSize: 18, lineHeight: 1.2, marginBottom: 4 }}>
                                        {this.state.selectedStudent.student_name || '—'}
                                    </div>
                                    <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap', alignItems: 'center' }}>
                                        {this.state.selectedStudent.admission_no && (
                                            <span style={{ background: 'rgba(255,255,255,0.18)', color: '#fff', borderRadius: 20, padding: '2px 10px', fontSize: 11, fontWeight: 700 }}>
                                                <i className="fas fa-id-card" style={{ marginRight: 4 }} />#{this.state.selectedStudent.admission_no}
                                            </span>
                                        )}
                                        {this.state.selectedStudent.roll_no && (
                                            <span style={{ background: 'rgba(255,255,255,0.18)', color: '#fff', borderRadius: 20, padding: '2px 10px', fontSize: 11, fontWeight: 700 }}>
                                                <i className="fas fa-list-ol" style={{ marginRight: 4 }} />Roll: {this.state.selectedStudent.roll_no}
                                            </span>
                                        )}
                                        {this.state.selectedStudent.gender && (
                                            <span style={{
                                                background: this.state.selectedStudent.gender.toLowerCase() === 'male' ? 'rgba(147,197,253,0.3)' : 'rgba(249,168,212,0.3)',
                                                color: '#fff', borderRadius: 20, padding: '2px 10px', fontSize: 11, fontWeight: 700
                                            }}>
                                                <i className={`fas fa-${this.state.selectedStudent.gender.toLowerCase() === 'male' ? 'mars' : 'venus'}`} style={{ marginRight: 4 }} />
                                                {this.state.selectedStudent.gender}
                                            </span>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </Modal.Header>

                        <Modal.Body style={{ padding: 0 }}>

                            {/* ── Document Stats Strip ── */}
                            <div style={{ display: 'flex', borderBottom: '1px solid #f1f5f9' }}>
                                {[
                                    { label: 'Submitted', count: this.state.selectedStudent.submitted_count || 0, icon: 'fa-check',        bg: '#16a34a', light: '#f0fdf4', text: '#15803d'  },
                                    { label: 'Pending',   count: this.state.selectedStudent.pending_count   || 0, icon: 'fa-clock',        bg: '#d97706', light: '#fffbeb', text: '#92400e'  },
                                    { label: 'Returned',  count: this.state.selectedStudent.returned_count  || 0, icon: 'fa-reply',        bg: '#2563eb', light: '#eff6ff', text: '#1e40af'  },
                                ].map((stat, i, arr) => (
                                    <div key={stat.label} style={{
                                        flex: 1,
                                        display: 'flex', alignItems: 'center', justifyContent: 'space-around', gap: 8,
                                        padding: '10px 8px',
                                        background: stat.light,
                                        borderRight: i < arr.length - 1 ? '1px solid #f1f5f9' : 'none',
                                    }}>
                                        <div style={{ width: 26, height: 26, background: stat.bg, borderRadius: 7, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                                            <i className={`fas ${stat.icon}`} style={{ color: '#fff', fontSize: 11 }} />
                                        </div>
                                        <div>
                                            <div style={{ fontSize: 18, fontWeight: 800, color: stat.bg, lineHeight: 1 }}>{stat.count}</div>
                                            <div style={{ fontSize: 9, fontWeight: 700, color: stat.text, textTransform: 'uppercase', letterSpacing: '0.4px', marginTop: 2 }}>{stat.label}</div>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div style={{ padding: '20px 24px' }}>

                                {/* ── Student Info Grid ── */}
                                <div style={{ background: '#f8fafc', borderRadius: 14, padding: '16px 18px', marginBottom: 20, border: '1px solid #e2e8f0' }}>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 14 }}>
                                        <div style={{ width: 26, height: 26, background: `${PURPLE}15`, borderRadius: 7, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                            <i className="fas fa-user-circle" style={{ color: PURPLE, fontSize: 12 }} />
                                        </div>
                                        <span style={{ fontSize: 11, fontWeight: 800, color: PURPLE, textTransform: 'uppercase', letterSpacing: '0.6px' }}>Student Information</span>
                                    </div>
                                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '12px 20px' }}>
                                        {[
                                            { label: 'Branch',        icon: 'fa-code-branch', value: branchMap[String(this.state.selectedStudent.branch_id)] },
                                            { label: 'Class',         icon: 'fa-layer-group',  value: classMap[String(this.state.selectedStudent.class_id)] },
                                            { label: 'Section',       icon: 'fa-users',        value: sectionMap[String(this.state.selectedStudent.section_id)] },
                                            { label: 'Date of Birth', icon: 'fa-birthday-cake', value: this.state.selectedStudent.dob ? this.formatDate(this.state.selectedStudent.dob) : null },
                                            { label: 'Mobile',        icon: 'fa-phone',        value: this.state.selectedStudent.student_mobile },
                                            { label: 'Father Name',   icon: 'fa-male',         value: this.state.selectedStudent.father_name },
                                            { label: 'Father Phone',  icon: 'fa-phone-alt',    value: this.state.selectedStudent.father_phone },
                                            { label: 'Mother Name',   icon: 'fa-female',       value: this.state.selectedStudent.mother_name },
                                        ].filter(f => f.value).map((field, i) => (
                                            <div key={i}>
                                                <div style={{ fontSize: 10, color: '#9ca3af', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.4px', marginBottom: 2, display: 'flex', alignItems: 'center', gap: 4 }}>
                                                    <i className={`fas ${field.icon}`} style={{ fontSize: 9 }} />{field.label}
                                                </div>
                                                <div style={{ fontSize: 13, color: '#1f2937', fontWeight: 600 }}>{field.value}</div>
                                            </div>
                                        ))}
                                    </div>
                                </div>

                                {/* ── Submitted Documents ── */}
                                <div style={{ marginBottom: 14, background: '#f0fdf4', border: '1px solid #bbf7d0', borderRadius: 14, padding: '14px 16px' }}>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 10 }}>
                                        <div style={{ width: 28, height: 28, background: '#16a34a', borderRadius: 8, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                                            <i className="fas fa-check-circle" style={{ color: '#fff', fontSize: 12 }} />
                                        </div>
                                        <span style={{ fontWeight: 700, fontSize: 13, color: '#14532d' }}>Submitted Documents</span>
                                        <span style={{ background: '#16a34a', color: '#fff', borderRadius: 20, padding: '2px 10px', fontSize: 11, fontWeight: 700, marginLeft: 'auto' }}>
                                            {this.state.selectedStudent.submitted_count || 0}
                                        </span>
                                    </div>
                                    {/* Doc list with per-document comments */}
                                    {(this.state.selectedStudent.submitted_count || 0) > 0
                                        ? <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                                            {this._parseNames(this.state.selectedStudent.submitted_names).map((doc, i) => (
                                                <div key={i} style={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
                                                    <Badge className="dh-chip-green" style={{ display: 'inline-flex', alignSelf: 'flex-start', alignItems: 'center', padding: '4px 10px', fontSize: 12, fontWeight: 600, borderRadius: 8, whiteSpace: 'normal', maxWidth: '100%' }}>{doc}</Badge>
                                                    {docCommentMap[doc]?.collected_comments && (
                                                        <span style={{ fontSize: 11, color: '#166534', background: '#dcfce7', borderRadius: 6, padding: '3px 10px', display: 'inline-flex', alignItems: 'center', gap: 5, alignSelf: 'flex-start', border: '1px solid #bbf7d0' }}>
                                                            <i className="fas fa-comment-alt" style={{ fontSize: 9, flexShrink: 0 }} />
                                                            {docCommentMap[doc].collected_comments}
                                                        </span>
                                                    )}
                                                </div>
                                            ))}
                                          </div>
                                        : <span style={{ fontSize: 12, color: '#9ca3af', fontStyle: 'italic' }}>No documents submitted yet</span>
                                    }
                                </div>

                                {/* ── Pending Documents ── */}
                                <div style={{ marginBottom: 14, background: '#fffbeb', border: '1px solid #fde68a', borderRadius: 14, padding: '14px 16px' }}>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 10 }}>
                                        <div style={{ width: 28, height: 28, background: '#d97706', borderRadius: 8, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                                            <i className="fas fa-hourglass-half" style={{ color: '#fff', fontSize: 12 }} />
                                        </div>
                                        <span style={{ fontWeight: 700, fontSize: 13, color: '#78350f' }}>Pending Documents</span>
                                        <span style={{ background: '#d97706', color: '#fff', borderRadius: 20, padding: '2px 10px', fontSize: 11, fontWeight: 700, marginLeft: 'auto' }}>
                                            {this.state.selectedStudent.pending_count || 0}
                                        </span>
                                    </div>
                                    {(this.state.selectedStudent.pending_count || 0) > 0
                                        ? <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                                            {this._parseNames(this.state.selectedStudent.pending_names).map((doc, i) => (
                                                <div key={i} style={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
                                                    <Badge className="dh-chip-red" style={{ display: 'inline-flex', alignSelf: 'flex-start', alignItems: 'center', padding: '4px 10px', fontSize: 12, fontWeight: 600, borderRadius: 8, whiteSpace: 'normal', maxWidth: '100%' }}>{doc}</Badge>
                                                    {docCommentMap[doc]?.pending_comments && (
                                                        <span style={{ fontSize: 11, color: '#92400e', background: '#fef3c7', borderRadius: 6, padding: '3px 10px', display: 'inline-flex', alignItems: 'center', gap: 5, alignSelf: 'flex-start', border: '1px solid #fde68a' }}>
                                                            <i className="fas fa-comment-alt" style={{ fontSize: 9, flexShrink: 0 }} />
                                                            {docCommentMap[doc].pending_comments}
                                                        </span>
                                                    )}
                                                </div>
                                            ))}
                                          </div>
                                        : <span style={{ fontSize: 12, color: '#9ca3af', fontStyle: 'italic' }}>No pending documents</span>
                                    }
                                </div>

                                {/* ── Returned Documents ── */}
                                <div style={{ background: '#eff6ff', border: '1px solid #bfdbfe', borderRadius: 14, padding: '14px 16px' }}>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 10 }}>
                                        <div style={{ width: 28, height: 28, background: '#2563eb', borderRadius: 8, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                                            <i className="fas fa-reply" style={{ color: '#fff', fontSize: 12 }} />
                                        </div>
                                        <span style={{ fontWeight: 700, fontSize: 13, color: '#1e3a8a' }}>Returned Documents</span>
                                        <span style={{ background: '#2563eb', color: '#fff', borderRadius: 20, padding: '2px 10px', fontSize: 11, fontWeight: 700, marginLeft: 'auto' }}>
                                            {this.state.selectedStudent.returned_count || 0}
                                        </span>
                                    </div>
                                    {(this.state.selectedStudent.returned_count || 0) > 0
                                        ? <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                                            {this._parseNames(this.state.selectedStudent.returned_names).map((doc, i) => (
                                                <div key={i} style={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
                                                    <Badge className="dh-chip-blue" style={{ display: 'inline-flex', alignSelf: 'flex-start', alignItems: 'center', padding: '4px 10px', fontSize: 12, fontWeight: 600, borderRadius: 8, whiteSpace: 'normal', maxWidth: '100%' }}>{doc}</Badge>
                                                    {docCommentMap[doc]?.collected_comments && (
                                                        <span style={{ fontSize: 11, color: '#1e40af', background: '#dbeafe', borderRadius: 6, padding: '3px 10px', display: 'inline-flex', alignItems: 'center', gap: 5, alignSelf: 'flex-start', border: '1px solid #bfdbfe' }}>
                                                            <i className="fas fa-comment-alt" style={{ fontSize: 9, flexShrink: 0 }} />
                                                            {docCommentMap[doc].collected_comments}
                                                        </span>
                                                    )}
                                                    {docCommentMap[doc]?.return_comments && (
                                                        <span style={{ fontSize: 11, color: '#1e40af', background: '#bfdbfe', borderRadius: 6, padding: '3px 10px', display: 'inline-flex', alignItems: 'center', gap: 5, alignSelf: 'flex-start', border: '1px solid #93c5fd' }}>
                                                            <i className="fas fa-reply" style={{ fontSize: 9, flexShrink: 0 }} />
                                                            {docCommentMap[doc].return_comments}
                                                        </span>
                                                    )}
                                                </div>
                                            ))}
                                          </div>
                                        : <span style={{ fontSize: 12, color: '#9ca3af', fontStyle: 'italic' }}>No documents returned yet</span>
                                    }
                                </div>

                            </div>
                        </Modal.Body>

                        {/* ── Modal Footer ── */}
                        <Modal.Footer style={{ background: '#f8fafc', borderTop: '1px solid #e2e8f0', padding: '12px 24px', display: 'flex', justifyContent: 'flex-end', gap: 10 }}>
                            <button
                                onClick={this.closeDrawer}
                                style={{ background: '#fff', border: '1.5px solid #e2e8f0', borderRadius: 10, color: '#64748b', fontWeight: 700, fontSize: 13, padding: '8px 20px', cursor: 'pointer' }}
                            >
                                Close
                            </button>
                        </Modal.Footer>
                    </Modal>

                    {/* DELETE CONFIRM MODAL */}
                    <Modal
                        show={this.state.deleteModal}
                        onHide={() => this.setState({ deleteModal: false, deleteStudent: null })}
                        centered
                    >
                        <Modal.Header closeButton style={{ background: '#ffffff', borderBottom: '1px solid #f1f5f9', padding: '20px 24px' }}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: 14 }}>
                                <div style={{
                                    width: 38,
                                    height: 38,
                                    borderRadius: 10,
                                    background: '#fee2e2',
                                    border: '1px solid #fecaca',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    color: '#dc2626',
                                    fontSize: 16,
                                    flexShrink: 0
                                }}>
                                    <i className="fal fa-trash-alt" />
                                </div>
                                <div style={{ display: 'flex', flexDirection: 'column', textAlign: 'left' }}>
                                    <Modal.Title style={{ color: '#0f172a', fontWeight: 700, fontSize: 16, margin: 0, letterSpacing: '-0.01em' }}>
                                        Confirm Delete
                                    </Modal.Title>
                                    <span style={{ color: '#64748b', fontSize: 12, fontWeight: 500, marginTop: 2 }}>This action will permanently delete this document management entry</span>
                                </div>
                            </div>
                        </Modal.Header>
                        <Modal.Body className="p-4" style={{ color: '#475569', fontSize: 14 }}>
                            Are you sure you want to delete
                            <strong> {this.state.deleteStudent?.student_name} </strong>
                            entry?
                        </Modal.Body>
                        <Modal.Footer style={{ background: '#ffffff', borderTop: '1px solid #f1f5f9', padding: '16px 24px' }}>
                            <Button
                                style={{ background: '#ffffff', border: '1.5px solid #e2e8f0', borderRadius: '10px', color: '#64748b', fontWeight: 600, fontSize: '13px', padding: '8px 20px' }}
                                onClick={() =>
                                    this.setState({ deleteModal: false, deleteStudent: null })
                                }
                            >
                                Cancel
                            </Button>
                            <Button
                                style={{ background: '#dc2626', border: 'none', borderRadius: '10px', color: '#ffffff', fontWeight: 600, fontSize: '13px', padding: '8px 20px', boxShadow: '0 4px 12px rgba(220, 38, 38, 0.15)' }}
                                onClick={this.handleDeleteStudent}
                            >
                                Delete
                            </Button>
                        </Modal.Footer>
                    </Modal>

                    {/* Edit modal — triggered from table row edit button */}
                    <AddEntryModal
                        show={this.state.addEntryModal}
                        editMode={this.state.editMode}
                        editStudent={this.state.editStudent}
                        existingStudentIds={this.state.students.map(s => String(s.student_id))}
                        onSave={(data) => this.handleSaveEntry(data)}
                        onHide={() =>
                            this.setState({ addEntryModal: false, editMode: false, editStudent: null })
                        }
                    />

                </Container>

            </div>

        </> );

    }

}

export default compose(
    withRouter,
    withApollo
)(DocumentServiceHome);
